import DetailsPanel from './DetailsPanel';

export * from './DetailsPanel.types';

export { DetailsPanel };

export default DetailsPanel;
